<template>
  <div class="item flex flex-col gap-4 mx-4 w-11/12 xl:w-[1200px] h-fit xl:mx-auto mt-4">
    <div class="top">Habblet&nbsp;<span>Hot 5&trade;</span></div>
    <div class="grid grid-cols-1 xl:grid-cols-5 gap-2">
      <div class="box flex flex-col w-full" v-for="(f, i) in fasites" :key="i">
        <div class="rank"
             :class="{'gold': f.rank === 1, 'silver': f.rank === 2, 'bronze': f.rank === 3, 'white': f.rank > 3}">{{ f.rank
          }}
        </div>
        <div class="icon" :style="{backgroundImage: 'url('+f.icon+')'}"></div>
        <div class="info"
             :class="{'gold': f.rank === 1, 'silver': f.rank === 2, 'bronze': f.rank === 3, 'white': f.rank > 3}">
          <div class="fasite">{{ f.fasite }}</div>
          <div class="ouvintes"><span>{{ f.ouvintes }}</span>&nbsp;ouvintes</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getFansites } from '@/services/api.js'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const fasites = ref([])

async function getFS() {
  fasites.value = await getFansites()
}

let interval = null

onMounted(() => {
  getFS()
  interval = setInterval(getFS, 30000)
})

onBeforeUnmount(() => {
  if (interval) clearInterval(interval)
})

</script>

<style scoped>
.item {
  height: auto;
  background-color: var(--color1);
  border-radius: 12px;
  padding: 10px;
}

.item .top {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  font-weight: 300;
  line-height: 30px;
  user-select: none;
}

.item .top span {
  font-weight: 700;
}

.item .content {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.item .box {
  position: relative;
  background-color: #fff;
  border-radius: 12px;
  user-select: none;
  margin-right: 10px;
}

.item .box .rank {
  position: relative;
  width: 32px;
  height: auto;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  line-height: 32px;
  top: 10px;
  left: 10px;
}

.item .box .icon {
  width: 100%;
  height: 50px;
  background-repeat: no-repeat;
  background-position: center;
  margin: 4px 0;
}

.item .box .info {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  border-radius: 0 0 12px 12px;
}

/*noinspection ALL*/
.item .box .white {
  background-color: #E8EFFC;
  color: var(--color2);
}
.item .box > .blue {
  background-color: #60BEE1;
}
.item .box > .gold {
  background-color: #FFC107;
}
.item .box > .bronze {
  background-color: #CD7F32;
}
.item .box > .silver {
  background-color: #95A9BD;
}

.item .box .white .ouvintes {
  color: var(--color2);
}

.item .box .info div {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: #fff;
  margin-top: 14px;
}

.item .box .info .fasite {
  color: rgba(0, 0, 0, .55);
}

.item .box .info .ouvintes {
  margin-top: 4px;
}

.item .box .info .ouvintes span {
  font-weight: 700;
}

@media only screen and (max-width: 500px) {

  .item .content {
    display: block;
    width: 100%;
  }

  .item .content .box {
    width: calc(100% - 20px);
    margin: 10px 0 0 10px;
  }
}
</style>
